import loadingSvg from './loading.svg';

export default function Loading() {
  return (
    <div style={{display: 'flex', justifyContent: 'center'}}>
      <img src={loadingSvg} alt='loading' />
    </div>
  );
}
